export default __webpack_public_path__ + "static/media/327.be9cab0e.png";